// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { HubsAreaId } from './HubsAreaId'
import { HubsAreaNavigation } from './HubsAreaNavigation'
import { HubsAreaRoutes } from './HubsAreaRoutes'

const LazyHubsComponent = lazy(() => import('./HubsArea'))

const HubsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyHubsComponent />
  </SuspenseLoadingWrapper>
)

export const HubsArea = {
  id: HubsAreaId,
  requiredRight: BoumRight.AREA_HUBS,
  NavigationComponent: HubsAreaNavigation,
  route: {
    path: HubsAreaRoutes.route,
    component: HubsComponent,
  },
}
